import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {AuthProvider} from "react-oidc-context";
import {oidcConfig} from "./config/auth-config";
import {FirebaseIdentitaetProvider} from "./auth/FirebaseIdentitaet";

const onSigninCallback = () => {
  window.history.replaceState({}, document.title, "/");
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig} onSigninCallback={onSigninCallback}>
      <FirebaseIdentitaetProvider>
        <App />
      </FirebaseIdentitaetProvider>
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
